<template>
  <div
    class="div-containesr"
  >
   
    <div
      v-if="section === 'versions' && preprocess"
      style="background-color: white; min-height: 100px;"
    >
      <b-row style="padding-bottom:10px">
        <b-col md="6">
          <!---<h3>Digital Reconstruction Versions</h3> -->
        </b-col>
        <b-col md="6">
          <b-button
            style="float:right"
            variant="gradient-primary"
            class="rounded"
            size="sm"
            @click="section = 'add_version'; initData()"
          >
            ADD NEW VERSION
          </b-button>
        </b-col>
      </b-row>
      <b-row class="tablePagi">
        <b-col>
          
          <b-table
            v-if="preprocess"
            id="versionsTable"
            :fields="fields"
            :items="versions"
            responsive
            striped
            class="mb-0"
            :per-page="7"
            :current-page="currentPage"
            hover
            select-mode="single"
          >
            <template
              #cell(clusters)="data"
              style="text-align:center"
            >
          
              <b-badge
             
                v-for="(marker, index) in JSON.parse(data.value)"
                :key="index"
                class="m-50"
                @click="show_cluster_hierar(data.value)"
                :variant="(marker.marker_type === 'a')? 'light-info' : (marker.marker_type === 'Functional')? 'light-info' : 'light-info'"
              >
                {{ marker.cell_id }}
              </b-badge>
              
            </template>
            <template
              #cell(status)="data">
             <div>
              <div v-if="data.item.display_dig == 0">
                Pending to do 'Digital Reconstruction' 
              </div>
              <div v-else-if="data.item.display_dig == 1">
                Doing 'Digital Reconstruction'
                <div style="font-size:11px" v-if="data.item.time_update">
                  {{ data.item.time_update }}
                </div>
                <div v-else style="font-size:11px"  >
                    In queue
                </div>
              </div>
              <div v-else-if="data.item.display_image == 0">
                Refreshing image...
                <div style="font-size:11px" v-if="data.item.time_update">
                  {{ data.item.time_update }}
                </div>
                <div v-else style="font-size:11px"  >
                    In queue
                </div>
              </div>
              <div v-else-if="(data.item.display_dig == 2 && data.item.imagelist ==  '{}')" style="color:red">
                Cluster conflicts. 
              </div>
              <div v-else>
                Data available
              </div>
             </div>

            </template>
            <template
              #cell(id)="data"
              style="text-align:center"
            >
              <b-overlay
                :show="inTask.includes(data.value)"
                opacity="1"
                spinner-variant="primary"
                spinner-small
                rounded="md"
              >
                <template
                  v-slot:overlay
                >
                  <div style="display:flex; align-items: center; flex-direction: row;">
                    <b-spinner
                      small
                      type="grow"
                    />
                    <div class="ml-2">
                      <small v-if="progress(data.value) !== null">Last Update:<br> {{ progress(data.value) }}</small>
                    </div>
                  </div>
                </template>
              
                <b-button
                  variant="gradient-danger"
                  class="btn-icon rounded"
                  size="sm"
                  @click="delVersion(data.value)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
                
                <b-button
                  :disabled="false"
                  variant="gradient-primary"
                  class="rounded ml-50"
                  size="sm"
                  @click="generateDigital(data.value, data)"
                
                >
                  Digital reconstruction
                </b-button>
                <b-button
                  :disabled="data.item.display_image == 0 || data.item.imagelist == undefined || data.item.display_dig == 1"
                  variant="gradient-success"
                  class="rounded ml-50"
                  size="sm"
                  @click="showResults(data.value)"
               
                >
                  View data 
                </b-button>
              

              </b-overlay>
            </template>
          </b-table>
          <div v-if="versions.length > 7">

        
          <b-pagination
          v-if="versions.length > 7"
        v-model="currentPage"
        :total-rows="versions.length"
        :per-page="7">
      </b-pagination>
    </div>

        </b-col> </b-row>
    </div>
    <div
      v-if="section === 'add_version' && preprocess"
      class="div-container"
    >
      <b-row style="padding-bottom:10px">
        <b-col md="6" style="text-align: left; margin-bottom: 30px;">
          <h3>Add New Version</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <b-form-group
            label="Version Title"
            label-for="versionTitle"
          >
            <b-form-input
              id="versionTitle"
              v-model="versionTitle"
              placeholder="Enter Version Title"
              :state="(versionTitle.trim().length > 0) ? true : ((versionTitle.length === 0) ? null : false)"
            />
          </b-form-group>
          <b-form-group
            label="Description"
            label-for="versionDescription"
          >
            <b-form-textarea
              id="versionDescription"
              v-model="versionDescription"
              placeholder="Textarea"
              rows="3"
            />
          </b-form-group>
          <b-alert
            v-model="errors"
            v-height-fade.appear
            variant="danger"
            dismissible
          >
            <h4 class="alert-heading">
              There are some errors
            </h4>
            <div class="alert-body">
              <ul>
                <li
                  v-for="(error, index) in errorlist"
                  :key="index"
                >
                  {{ error }}
                </li>
              </ul>
            </div>
          </b-alert>
          <div class="button-space">
            <b-button
              variant="outline-danger"
              class="btn-icon rounded mt-2 mb-0"
              size="md"
              @click="cancelVersion"
            >
              CANCEL
            </b-button>
            <b-button
              variant="outline-success"
              class="btn-icon rounded mt-2 mb-0"
              size="md"
              @click="saveVersion"
            >
              SAVE
            </b-button>
          </div>
        </b-col>
        <b-col md="9" >
          <div class="clusterList">

     

            <div style="min-height: 400px;     text-align: left;" v-if="treeData.length > 0">
             <h6> Select Clusters:</h6> 

              <div style=" background: white;">
             <!----
                <div class="clust" style="width:60%">
                 
                  <v-select v-model="search" :options="cluster_options" placeholder="Search cluster.." style="background-color: white;" />  
                </div>-->
                
                            
                <liquor-tree
                v-show="treeChange"
                :data="treeData"
                v-model="treeData2"
                :options="treeOptions"
                @node:checked="onNodeSelected"
                @click="checkTreeData($event)"
              />
           

              </div>
            
              
                
            
            </div>
            <div v-else style="min-height: 400px;     text-align: left;" >
              No clusters available
            </div>
            <!----<div style="display='none'">
           
              <h6>Included clusters</h6>

              <div
                :list="included"
                :group="{name: 'tags'}"
                class="mb-1 marker-selectable"
              >
                <b-badge
                  v-for="(marker, index) in included"
                  :key="index"
                  class="m-50"
                  style="cursor:pointer"
                  :variant="(marker.marker_type === 'Phenotypic')? 'light-info' : (marker.marker_type === 'Functional')? 'light-info' : 'light-info'"
                  
                >
                  {{ marker.cell_id }}
                </b-badge>
              </div>
            </div>-->
          </div>
          
        </b-col></b-row></div>
  </div>
</template>
<script>
import Vue from 'vue'
import LiquorTree from 'liquor-tree'
import vSelect from 'vue-select'
import ClusterHierar from './tabs/project/DigitalReconstruction/ClusterHierar.vue'
import {
  BRow, BCol, BBadge, BTable, BButton, BFormInput, BFormTextarea, BFormGroup, BAlert, BOverlay, BSpinner, BPagination
} from 'bootstrap-vue'

import store from '@/store/index'
import axios from 'axios'
import { heightFade } from '@core/directives/animations'
import SelectCells from './tabs/project/DigitalReconstruction/SelectCells.vue'

const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}
import DigitalReconstruction from './tabs/project/DigitalReconstruction/Digital.vue'

export default {
  components: {
    BRow,
    BPagination,
    LiquorTree,
    BCol,
    BBadge,
    BTable,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BAlert,
    BOverlay,
    BSpinner,
    SelectCells,
    vSelect,
    DigitalReconstruction,
    ClusterHierar
  },
  directives: {
    'height-fade': heightFade,
  },
  props: {
    selected: {
      required: true,
      type: Boolean,
    },
    preprocess: {
      required: true,
      type: Boolean,
    },
    status: {
      required: true,
      type: [Object, Array, String, null],
    },
    project_id: {
      required: true,
      type:Number,
      default:0
    },
    show_data: {
      required: true,
      type:Number,
      default:0
    }
  },
  data() {
    return {
      section: 'versions',
      treeChange: true,
      currentPage:0,
      treeOptions: 
      {
   
        checkbox: true,
        multiple: true,
        expanded: true
        
      },
      treeData2:[],
      testing:0,
      treeData : [
       
        // and so on ...
      ],
      clusters_content: {
        'Blank': [{id:1, version:2}],
        'M1like Macrophages': [{id:1, version:2}]

      },
      cluster_options: ['Blank','M1like Macrophages'],
      nonIncluded: [{marker_type:'a',cell_id: 'Blank'},{marker_type:'a',cell_id: ' M1like Macrophages'}],
      included: [],
      search:'',
      computing: [],
      computed: true,
      process: false,
      clusters2send:[],
      fields: [
        { key: 'idv', label: 'ID', sortable: false },
        { key: 'title', label: 'Title', sortable: true },
        { key: 'description', label: 'Description', sortable: true },
        { key: 'user', label: 'Author', sortable: true },
        { key: 'clusters', label: 'Included clusters', sortable: true },
        { key: 'created_at', label: 'Created At', sortable: true },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'id', label: '', sortable: false },
       
      ],
      versions: [],
      versionImages: [],
      versionTitle: '',
      versionDescription: '',
      errors: false,
      errorlist: [],
      username: '',
      tasktype_status: [],
      inTask: [],
      timer:null,
      timerData:null
    }
  },
  watch: {
    section: function(value){
      console.log("Value changed", value)
      if(value == 'versions'){
        this.clusters2send = []
      }

    },
    search: function(value){
      const { treeData, clusters_content} = this
      const parentVersion = clusters_content[value]
      var parentIds = []
      var versionIds = []
      parentVersion.forEach(function(item){
        parentIds.push(item.id)
        versionIds.push(item.version_id)
      })

      var temp_data = treeData;
      for(var i=0; i< treeData.length;i++){
        if(parentIds.includes(treeData[i].id)){
          temp_data[i].state.expanded = true;

        }
      }
     
      this.treeData = temp_data;
    


    },
    treeData2: function(value){
      var includedMark = []
      const prueba = value.checked.map(el => el) 
      for(var i=0; i< prueba.length;i++){
          if(prueba[i].id > 1000){
          
            includedMark.push({cell_id: prueba[i].text, marker_type:'a'})
          }
         
        
      

      }
     
      if(prueba.length == 0){
        this.included = []
      }
      else{
        this.included = includedMark
      }
      //console.log(treeDataH['selected'])
    },
   
    status() {
      if (this.status.tasktype_status.length > 0) {
        this.tasktype_status = this.status.tasktype_status
      } else if (this.tasktype_status.length > 0) {
        this.tasktype_status = []
      }
    },
    tasktype_status() {
      this.checkInTask()
      if (this.tasktype_status.length === 0) {
        this.getVersions()
        this.process = false
      }
    },
  },
  created(){
   
  },
  mounted() {
    this.section = 'versions'
    //this.getMarkers()
    console.log("i reloadddd")

    this.getVersions()
    this.getDigitalVersions()
    
   
    
    this.getDigitalVersions() 
    this.username = (`${store.state.user.userdata.name} ${store.state.user.userdata.lastname}`).trim()
    this.timerData = setInterval(() => {
    
    if(this.show_data == 1 && this.$route.name == 'Downstream Analysis'){
      this.getVersions()   
    }else{
      this.section = 'versions'
      this.clusters2send = []
    }
   
    }, 1000)
  },
  methods: {
    initData(){
      this.getVersions()
      this.getDigitalVersions()
    },
    show_cluster_hierar(value){
     
      var moment_clusters = JSON.parse(value)
      const clustersHierarchy = new Vue({
      ...ClusterHierar,

      propsData: { data: moment_clusters},
    }).$mount()
    this.$swal({
      html: clustersHierarchy.$el,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      confirmButtonText: 'Save',
      width: '90%',
    


    }).then(async result => {
      //setInterval(this.timer)
        if (result.dismiss == undefined) {
          
        }
      })
    },
    getTimeStatus(time){
      if(time ==null || time == undefined){
        return 'In queue'
      }
      return time

    },
    getDigitalVersions() {
    
      
        const id= this.$route.params.id
        var treeData = []
       
       
      //const id = 32;
      axios.get(`${url}:${port}/downstream-versions/${id}/0`, { headers }).then(async result => {
        if (result) {
          const DigVersions = []
       
          result.data.versions.forEach(element => {
          
            // eslint-disable-next-line no-param-reassign
            if(element.display_split == 3){
              DigVersions.push(element)
            }
  
          
          })
          
          for (let index = 0; index < DigVersions.length; index++) {
        
              var node_id = DigVersions[index].node_id
              var version_name = DigVersions[index].title
              var node_name = DigVersions[index].node_name
              var version_id = DigVersions[index].id
              var annots = []
              try{
              var annots = Object.keys(JSON.parse(DigVersions[index].final_clusters))
              }catch(e){
                annots = []
              }
              //var annots = JSON.parse(DigVersions[index].annotation).filter(e => e.annotated == 1)
              var annots_clusters = []
              var includedCluster = []
              var nonIncluded = []
              
              for(var i=0;i< annots.length;i++){
                //if(includedCluster.includes(annots[i].annotation) == false){
                  if(includedCluster.includes(annots[i]) == false){
                  var id = annots[i] + "_" +version_id + "_" + node_id  + "_" +  version_name + "_" + node_name
                  annots_clusters.push({text: annots[i], is_cell: true, version_id: version_id, node_id: node_id, id: id})
                  includedCluster.push(annots[i])
                  nonIncluded.push({marker_type:'a',cell_id: annots[i]})
                }
                
              }
              
              var contains = 0
              for(var x = 0;x < treeData.length; x++){
                if(treeData[x].id == node_id){
                  treeData[x]['children'].push({text:DigVersions[index].title, id: DigVersions[index].id, children: annots_clusters})
                  contains = 1
                  continue
                }
              }
                if(contains == 0){
                  treeData.push({text: node_name, id: DigVersions[index].node_id, children: [{text:DigVersions[index].title, id: DigVersions[index].id, children: annots_clusters}] })

                }
                this.nonIncluded = nonIncluded
              
          }
        }})
        this.treeData = treeData
      
      
    },
    showResults(dr_id){
   
      //clearInterval(this.timer)
      const { project_id} = this
  
    const digitalRec = new Vue({
      ...DigitalReconstruction,

      propsData: { version:dr_id, project_id: project_id},
    }).$mount()
    this.$swal({
      html: digitalRec.$el,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      confirmButtonText: 'Save',
      width: '90%',


    }).then(async result => {
      //setInterval(this.timer)
        if (result.dismiss == undefined) {
          
        }
      })

    },
    sendDigital(dr_id){
      const { id } = this.$route.params
      console.log("GEnerate digital", id)
      const { clusters2send} = this
      var clusters = clusters2send
      axios.put(`${url}:${port}/downstream-dig-images/${id}/${dr_id}`, { clusters}, { headers })
      
    },
    generateDigital(dr_id, data){
      if(data.item.display_dig == 2){
        this.preClustering(dr_id)
        return
      }
      this.sendDigital(dr_id)
      
    
    },
    onNodeSelected(node) {
          var node_id = node.id
          try{
          if(node_id.includes("_"))
          {
            var clust = node_id.split("_")
           
            this.clusters2send.push({cell_id:clust[0], version_id:clust[1], node_id: clust[2], version_name: clust[3], node_name : clust[4]})

          }
        }catch{}
    
        },
    checkTreeData(e){
      console.log("Check tree",e)
    },
    progress(version) {
      const tasks = ['10.2', '10.3', '10.4']
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.tasktype_status.length; index++) {
        const element = this.tasktype_status[index]
        if (element.json.version_id === version && tasks.includes(element.json.task_type)) {
          return (element.progress !== null) ? element.progress.timestamp : null
        }
      }
      return null
    },
    checkInTask() {
      const intask = []
      const tasks = ['10.2', '10.3', '10.4']
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.tasktype_status.length; index++) {
        const element = this.tasktype_status[index]
        if (tasks.includes(element.json.task_type)) {
          console.log(element)
          intask.push(element.json.version_id)
          this.process = true
        }
      }
      this.inTask = intask
    },
    preClustering(version) {
      this.$swal({
        title: 'Are you sure?',
        text: "All digital reconstruction will be deleted. You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'YES',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.sendDigital(version)
        }
      })
    },
    clustering(version) {
      this.process = true
      const { id } = this.$route.params
     // const id = this.project_id;
      if (this.version !== null) {
        this.computing.push(version)
        axios.post(`${url}:${port}/downstream-clustering/${id}`, { version, user_id: 1 }, { headers })
      }
    },
    hasImages(id) {
      return (this.versionImages.includes(id))
    },
    include(marker, index) {
      this.included.push(marker)
      this.nonIncluded.splice(index, 1)
    },
    noinclude(marker, index) {
      this.nonIncluded.push(marker)
      this.included.splice(index, 1)
    },
    getMarkers() {
      const { id } = this.$route.params
      //const id = 32;
      console.log('getMarkers')
      axios.get(`${url}:${port}/downstream-markers/${id}`, { headers }).then(result => {
        if (result) {
          this.included = []
         // this.nonIncluded = (result.data.markers.non_included)
        }
      
      })
    },
    getVersions() {
      this.computing = []
      const { id } = this.$route.params
     // const id = this.project_id;
      axios.get(`${url}:${port}/downstream-dig-versions/${id}`, { headers }).then(result => {
        if (result) {
          const versions = []
          result.data.versions.forEach(element => {
            // eslint-disable-next-line no-param-reassign
            element.idv = element.id
            versions.push(element)
          })
         // versions[0]['description'] = 'Primera prueba'
          //versions[0]['idv'] = '3'
          this.versions = versions
         // this.section = 'versions'
          // eslint-disable-next-line no-plusplus
          for (let index = 0; index < this.versions.length; index++) {
            const element = this.versions[index]
            if (element.hasImages) {
              this.versionImages.push(element.id)
            }
          }
        }
      })
    },
    cancelVersion() {
      if (this.errors) {
       this.timer =  setTimeout(this.changeSection, 500)
      } else {
        this.changeSection()
      }
      this.errors = false
      this.errorlist = []
      this.getMarkers()
      this.versionTitle = ''
      this.versionDescription = ''
    },
    changeSection() {
      this.section = 'versions'
    },
    saveVersion() {
      this.errors = false
      this.errorlist = []
      const versionTitle = this.versionTitle.trim()
      let allCorrect = true
      if (versionTitle.length === 0) {
        allCorrect = false
        this.errorlist.push('Version Title is requered')
      }
      if (this.clusters2send.length === 0) {
        allCorrect = false
        this.errorlist.push('An included Cluster is required')
      }
      if (allCorrect) {
        const { id } = this.$route.params
       // const id= 32;
        const title = this.versionTitle
        const description = this.versionDescription
        const user = this.username
        const clusters = this.clusters2send
        
        axios.post(`${url}:${port}/downstream-dig-versions/${id}`, {
          title, description, clusters, user,
        }, { headers }).then(async result => {
          if (result) {
            //this.getVersions()
            this.section = 'versions'
            this.errorlist = []
            this.versionTitle = ''
            this.versionDescription = ''
            /*this.getVersions()
            this.included = []
            this.nonIncluded = result.data.markers.non_included
            this.errors = false
            this.errorlist = []
            this.versionTitle = ''
            this.versionDescription = ''*/
          }
        })
      } 
      else {
        this.errors = true
      }
    },
    delVersion(id) {
      // eslint-disable-next-line no-restricted-globals, no-alert
      if (confirm('Selected version will be deleted')) {
        axios.delete(`${url}:${port}/downstream-digital/${id}`, { headers }).then(result => {
          if (result) {
            this.getVersions()
          }
        })
      }
    },
    selectVersion(id) {
      const selVersion = this.versions.find(version => version.id === id)
      this.$emit('selversion', selVersion)
    },
  },
}
</script>
<style>
.div-container{
/*min-height: calc(100vh - 325px);*/
font-size:15px !important;
margin-top:20px;
}
#versionsTable{
  margin-bottom: 20px;
}
#versionsTable td[aria-colindex="2"],
#versionsTable td[aria-colindex="3"]{
  min-width: 250px
}
#versionsTable td[aria-colindex="5"]{
  width: 201px
}
#versionsTable td[aria-colindex="6"]{
  width: 400px
}
.button-space{
   display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: flex-start;align-items: center;
}
.button-space button{
    margin-right: 15px;
}
.clusterList{
  display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    align-items: stretch;
    align-content: center;
    background-color: white !important;
}
.cluster-cellss{
  background-color: yellow;
}
.clusterList div{
  flex: 0 0 50%;
}
.clusterList h6{
  margin-left: 10px;
}
.tree-checkbox .checked{
  width:15px !important;
  height: 15px !important;
}
.tree-checkbox.checked::after {
  left: 3px !important;
  height: 10px !important;
  width: 6px !important;
  top: 0 !important;
}
.clust{
  padding-top:10px;
  padding-left: 5px;
}
.clust .vs__actions{
  display:none;
}
.tablePagi .pagination {
  justify-content: center;;

}

</style>
<style scoped>
.marker-selectable{
  background: whitesmoke;
  padding: 10px;
  margin: 10px;
  height: calc(100% - 30px)
}


</style>
